<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="入稿ファイルをアップロード" />
    </v-flex>
    <v-flex xs12 mt-4 offset-xs1>
      <AppFileDropArea
        :mime-types="mimeTypes"
        @files="onDropFile"
        class="file-wrapper"
      >
        <v-layout class="dropArea pa-2 mb-1 justify-center align-center">
          ここに入稿用ファイルをドラッグ
        </v-layout>
        <template v-slot:drag>
          <v-layout
            class="dropArea dragging pa-2 mb-1 justify-center align-center"
          >
            ドロップして入稿用ファイルの内容を読み込む
          </v-layout>
        </template>
      </AppFileDropArea>
    </v-flex>
    <v-flex v-if="uploadFile.fileName" xs10 mt-3 offset-xs1>
      <AppForm label="ファイル名" />
    </v-flex>
    <v-flex v-if="uploadFile.fileName" xs10 offset-xs2>
      <AppForm :label="uploadFile.fileName" />
    </v-flex>
    <v-flex xs12 mt-3 offset-xs1>
      <p>
        ※ 複数のファイルを読み込む場合はzipファイルにして読み込んで下さい。<br />
        入稿用フォーマットについては、担当営業にお問い合わせください。
      </p>
    </v-flex>
    <v-flex xs12>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.orderDescription.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import { mimeTypes } from '@/components/App/AppFileDropArea'
export default {
  name: 'CampaignModalPageCustom',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    uploadFile() {
      return this.menuSetting.uploadFile
    },
    errorMessage() {
      if (!this.menuSetting.isNew) return ''
      if (
        this.uploadFile.fileName === '' &&
        this.menuSetting.orderDescription.memo === ''
      ) {
        return '入稿情報が登録されていません。\n入稿ファイルのアップロードもしくは、備考欄へ入稿情報を記載して下さい。'
      }
      return ''
    },
    mimeTypes() {
      return Object.values(mimeTypes.csv)
        .concat(Object.values(mimeTypes.document))
        .concat(Object.values(mimeTypes.multiple))
    },
  },
  methods: {
    onDropFile(files) {
      const [file] = files
      this.uploadFile.file = file
      this.uploadFile.fileName = file.name
    },
  },
}
</script>

<style scoped>
.file-wrapper {
  border: 1px dotted #666;
  height: 150px;
  transition: height 0.5s linear;
}

.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
